import get from "lodash/get";
import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import { IntlProvider } from "react-intl";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { CheckActionPermission } from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import Select from "react-select";

import DrawerHeader from "../../../../../../Component/Headers/drawerHeader";
import TabContainer from "../../../../../../Component/Common/TabContainer";
import { instance } from "../../../../../../Actions/AxiosInstance";
import { setPreview as setPreviewAction } from "../../../../../../Actions/commonAction";
import PageHeader from "../../../../../../Component/Headers/pageHeader";
import filterIcon from "../../../../../../Assets/newicons/action/filter/outline/filter-outline-16px.svg";
import { List, TDTypeConsts } from "../../../../business-configration/commons";
import Create from "./create";
import { ErrorMessages } from "../../../../../../Constants";
import SearchSq from "../../../../../../Component/Material-ui/SearchSq";
import DefaultComp from "../../../../../../Component/DefaultComp/Defaultstatecomp";
import emptyHrlist from "../../../../../../Assets/Svg/hr-letters-custom-templates.svg";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { selectinputconverter } from "../../../../../../Component/DynamicForm/Fields/Select";
import VARIBALES from "./variables";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

let global = [];
class Templates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      DrawerOpen: false,
      permissions: { editable: false, readonly: false },
      letterVariables: [],
      modules1: {
        toolbar: {
          container: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["clean"],
            [{ placeholder: [] }],
          ],
          handlers: {
            placeholder(value) {
              const obj = global.find((x) => x.displayname == value);
              if (value) {
                const cursorPosition = this.quill.getSelection().index;
                this.quill.insertText(cursorPosition, `{${obj.variablevalue}}`);
                this.quill.setSelection(
                  cursorPosition + obj.variablevalue.length + 2,
                );
              }
            },
          },
        },
        clipboard: {
          matchVisual: false,
        }
      },
      modules2: {
        toolbar: {
          container: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["clean"],
            [{ placeholder: [] }],
          ],
          handlers: {
            placeholder(value) {
              console.log("this: ", this);
              const obj = global.find((x) => x.displayname == value);
              if (value) {
                const cursorPosition = this.quill.getSelection().index;
                this.quill.insertText(cursorPosition, `{${obj.variablevalue}}`);
                this.quill.setSelection(
                  cursorPosition + obj.variablevalue.length + 2,
                );
              }
            },
          },
        },
        clipboard: {
          matchVisual: false,
        }
      },
      defaultTemplates: {
        headers: [
          {
            key: "templatename",
            name: "Template name",

            style: { textAlign: "left", width: "40%" },
          },
          {
            key: "categoryname",
            name: "Category name",
            type: TDTypeConsts.OTHERS,
          },
          {
            key: "isactive",
            name: "Status",
            type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
          },
          {
            key: "preview",
            name: "",
            type: TDTypeConsts.DOCUMENT_PREVIEW,
          },
        ],
        data: [],
      },
      customTemplates: {
        headers: [
          {
            key: "templatename",
            name: "Template name",
            style: { textAlign: "left", width: "40%" },
          },
          {
            key: "categoryname",
            name: "Category name",
            type: TDTypeConsts.OTHERS,
          },
          {
            key: "isactive",
            name: "Status",
            type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
          },
          {
            key: "preview",
            name: "",
            type: TDTypeConsts.DOCUMENT_PREVIEW,
          },
          {
            key: "edit",
            name: "",
            type: TDTypeConsts.EDIT_WITHOUT_HEADER,
            style: { width: "8%" },
          },
          {
            key: "delete",
            name: "",
            type: TDTypeConsts.DELETE_WITHOUT_HEADER,
            style: { width: "8%" },
          },
        ],
        data: [],
      },
      lettercategories: [],
      lettercategoryid: null,
      selecteddata: null,
      searchValue: "",
      backupList: [],
      selectedEmployeeIds: null,
      selectedEmployees: null,
      allemployeeslist: [],
    };

    this.onEdit = this.onEdit.bind(this);
    this.getTemplates = this.getTemplates.bind(this);
    this.renderList = this.renderList.bind(this);
    this.renderCreate = this.renderCreate.bind(this);
    this.renderEdit = this.renderEdit.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.searchTemplate = this.searchTemplate.bind(this);
    this.handleClickAway = this.handleClickAway.bind(this);
    this.onStateStatusChange = this.onStateStatusChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onPreview = this.onPreview.bind(this);
    this.createLetterConfig = this.createLetterConfig.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("templates");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getTemplates();
        this.getLetterCategories();
        this.getLetterVariables();
        this.getAllEmp();
        if (
          this.props.history.location.pathname.includes("create") ||
          this.props.history.location.pathname.includes("edit")
        ) {
          this.props.history.push(`${this.props.match.path}`);
        }
        if (!this.state.permissions.editable) {
          const index = this.state.customTemplates.headers.findIndex(
            (x) => x.type == TDTypeConsts.EDIT_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.customTemplates.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index = this.state.customTemplates.headers.findIndex(
            (x) => x.type == TDTypeConsts.DELETE_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.customTemplates.headers.splice(index, 1);
          }
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  openDrawer(DrawerOpen) {
    this.setState({
      DrawerOpen,
    });
  }

  getAllEmp() {
    const { login } = this.props.AuthenticationAction;
    const data = {
      featurekey: "templates",
      subscriptionid: login.subscriptionid,
    };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        this.setState({
          allemployeeslist: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getLetterConfig() {
    instance
      .get(`letter/getconfig`)
      .then((result) => {
        const [ objCCEmpData] = result.data.result;
        const ccemployeelist = objCCEmpData?.ccemployeeids || '';
        // const selectedEmployees = this.state.allemployeeslist.filter(
        //   (x) =>
        //     ccemployeelist && ccemployeelist.findIndex((y) => y == x) == -1,
        // );
        const selectedEmployees = this.state.allemployeeslist.filter((emp) =>
          ccemployeelist.includes(emp.displayvalue),
        );
        this.setState({
          selectedEmployees,
          ccemployeelist,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  createLetterConfig() {
    if (!this.state.selectedEmployees) {
      this.props.enqueueSnackbar("Please select employee(s)", {
        variant: "error",
      });
      return;
    }

    const data = { ccemployeeids: this.state.selectedEmployeeIds };
    instance
      .post(`letter/createconfig`, data)
      .then(() => {
        this.props.enqueueSnackbar("Created succesfully", {
          variant: "success",
        });
        this.setState({
          DrawerOpen: false,
          isccemployees: false,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getTemplates() {
    const { value, lettercategoryid } = this.state;
    instance
      .post("letter/getalllettertemplate", {
        iscustom: value == 0 ? false : true,
        lettercategoryid,
      })
      .then((resp) => {
        if (value == 0) {
          this.setState({
            defaultTemplates: {
              ...this.state.defaultTemplates,
              data: resp.data.result,
            },
            backupList: resp.data.result,
          });
        } else {
          this.setState({
            customTemplates: {
              ...this.state.customTemplates,
              data: resp.data.result,
            },
            backupList: resp.data.result,
          });
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getLetterCategories() {
    instance
      .get("superuser/getlettercategorylist")
      .then((result) => {
        this.setState({
          lettercategories: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getLetterVariables() {
    instance
      .get("superuser/getlettervariablelist")
      .then((result) => {
        const { modules1, modules2 } = this.state;
        modules1.toolbar.container[6][0].placeholder = result.data.result
          .filter((x) => !x.iscustom && x.displayvalue != VARIBALES.letterlink)
          .map((x) => x.displayname);
        modules2.toolbar.container[6][0].placeholder = result.data.result
          .filter((x) => !x.iscustom && x.displayvalue != VARIBALES.signatory)
          .map((x) => x.displayname);
        this.setState(
          {
            letterVariables:
              result.data.result.filter((x) => !x.iscustom) || [],
            modules1,
            modules2,
          },
          () => {
            global = this.state.letterVariables;
          },
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  searchTemplate(e) {
    const { value, defaultTemplates, customTemplates, backupList } = this.state;
    const list = value == 0 ? defaultTemplates.data : customTemplates.data;
    const filterList = list.filter(
      (item) =>
        item.templatename.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    this.setState({
      searchValue: e.target.value,
      defaultTemplates: {
        ...defaultTemplates,
        data: e.target.value ? filterList : backupList,
      },
      customTemplates: {
        ...customTemplates,
        data: e.target.value ? filterList : backupList,
      },
    });
  }

  onPreview(row) {
    const data = {
      isongoing: false,
      subscriptionlettertemplateid: row.subscriptionlettertemplateid,
      ismaster: false,
    };
    instance
      .post("letter/previewtemplate", data)
      .then((result) => {
        const link = `data:application/pdf;base64,${result.data.result[0].content.buffer.data}`;
        this.props.setPreview({
          show: true,
          type: "doc",
          data: link,
          name: "Template.pdf",
          ext: "pdf",
          isbase64: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleClickAway() {
    this.setState({
      DrawerOpen: false,
      lettercategoryid: null,
      isfilter: false,
      isccemployees: false,
    });
  }

  handleTabChange(value) {
    this.setState(
      {
        value,
      },
      () => {
        this.getTemplates();
      },
    );
  }

  handleChange(key, value) {
    if (key == "selectedEmployeeIds") {
      this.setState({
        selectedEmployees: value,
        // [key]: value && value.map((x) => x.displayvalue).join(","),
        [key]: value && value.map((x) => x.displayvalue),
      });
    } else {
      this.setState({ [key]: value });
    }
  }

  onSubmit() {
    const { lettercategoryid } = this.state;
    if (lettercategoryid) {
      this.getTemplates();
      this.setState({
        DrawerOpen: false,
      });
    } else {
      this.props.enqueueSnackbar("Please select letter category id", {
        variant: "error",
      });
    }
  }

  renderCreate() {
    return (
      <Create
        {...this.props}
        {...this.state}
        getTemplates={this.getTemplates}
        onCancel={this.onCancel}
        setPreview={this.props.setPreview}
        handleClickAway={this.handleClickAway}
      />
    );
  }

  renderEdit() {
    return (
      <Create
        {...this.props}
        {...this.state}
        getTemplates={this.getTemplates}
        onCancel={this.onCancel}
        setPreview={this.props.setPreview}
        handleClickAway={this.handleClickAway}
      />
    );
  }

  onCreate() {
    this.setState(
      {
        selecteddata: {
          templatename: null,
          lettercategoryid: null,
          bodypath: null,
          bodyvariableids: null,
          subject: null,
          subjectvariableids: null,
          emailbodypath: null,
          emailvariableids: null,
          subscriptionlettertemplateid: null,
          deletefile: null,
        },
      },
      () => {
        this.props.history.push(`${this.props.match.path}/create`);
      },
    );
  }

  onEdit(item) {
    instance
      .post("letter/getlettertemplatebyid", {
        ismaster: false,
        subscriptionlettertemplateid: item.subscriptionlettertemplateid,
      })
      .then((result) => {
        if (get(result, "data.result[0]", "")) {
          this.setState(
            {
              selecteddata: {
                ...result.data.result[0],
                btemplatebody: result.data.result[0].templatebody,
                bemailbody: result.data.result[0].emailbody,
                bbodypath: result.data.result[0].bodypath,
                bemailbodypath: result.data.result[0].emailbodypath,
              },
            },
            () => {
              this.props.history.push(`${this.props.match.path}/edit`);
            },
          );
        }
      });
  }

  onDelete = (item) => {
    instance
      .delete(
        `letter/deletelettertemplate/${item.subscriptionlettertemplateid}`,
      )
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0120, { variant: "success" });
        this.getTemplates();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  onCancel() {
    this.setState(
      {
        selecteddata: null,
        DrawerOpen: false,
      },
      () => {
        this.props.history.push(`${this.props.match.path}`);
      },
    );
  }

  onStateStatusChange(val, row) {
    // const { value } = this.state;
    const data = {
      subscriptionlettertemplateid: row.subscriptionlettertemplateid,
      isactive: !row.isactive,
      ismaster: false,
    };
    // this.props.enqueueSnackbar(ErrorMessages.E1070, {
    //   variant: "warning",
    //   action: [
    //     <Button
    //       color="inherit"
    //       size="small"
    //       onClick={() => {
    instance
      .post("letter/activeinactivelettertemplate", data)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.getTemplates();
        // this.props.closeSnackbar();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
    //     }}
    //     >
    //       Yes
    //     </Button>,
    //     <Button color="inherit" size="small" onClick={() => this.props.closeSnackbar()}>
    //       No
    //     </Button>,
    //   ],
    // });
  }

  renderList() {
    const { value, customTemplates } = this.state;
    console.log("customTemplates: ", customTemplates);
    return (
      <div>
        <Helmet>
          <title>{headersList.Config.Templates.header}</title>
        </Helmet>
        <Grid container>
          <Grid item xs={12} md={2} sm={2}>
            <PageHeader header="Templates" />
          </Grid>
          <Grid
            item
            xs={12}
            md={10}
            sm={2}
            justify="flex-end"
            className="display-flex"
          >
            <div className="floatleft margin-right-16">
              <SearchSq
                placeholder="Search templates"
                value={this.state.searchValue}
                onChange={this.searchTemplate}
              />
            </div>

            <div
              className="floatleft margin-right-16 filter-icon"
              onClick={() =>
                this.setState({
                  DrawerOpen: true,
                  isfilter: true,
                  isccemployees: false,
                })
              }
            >
              <img src={filterIcon} className="vertical-center"></img>
            </div>
            {this.state.permissions.editable && value == 1 && (
              <span className="floatleft">
                <Button
                  variant="contained"
                  className="btn btn-primary-md-blue"
                  color="primary"
                  onClick={this.onCreate}
                >
                  New template
                </Button>
              </span>
            )}
          </Grid>
        </Grid>
        <div>
          <div
            className="display-flex"
            style={{ alignItems: "center", justifyContent: "space-between" }}
          >
            <Tabs
              value={value}
              // onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              scrollButtons="auto"
              style={{ width: "50%" }}
            >
              <Tab
                label="sumHR templates"
                className="width50"
                onClick={() => this.handleTabChange(0)}
              />
              <Tab
                label="Custom templates"
                className="width50"
                onClick={() => this.handleTabChange(1)}
              />
            </Tabs>
            <div>
              <p
                className="normal-blue t-bold cursor-pointer"
                onClick={() =>
                  this.setState(
                    {
                      DrawerOpen: true,
                      isfilter: false,
                      isccemployees: true,
                    },
                    () => {
                      this.getLetterConfig();
                    },
                  )
                }
              >
                Letter config
              </p>
            </div>
          </div>

          <div className="margin-top-24">
            {value == 0 && (
              <TabContainer>
                <List
                  showOnlyList
                  list={this.state.defaultTemplates.data}
                  permissions={this.state.permissions}
                  headers={this.state.defaultTemplates.headers}
                  onEdit={this.onEdit}
                  onPreview={this.onPreview}
                  onDelete={this.onDelete}
                  onStateStatusChange={this.onStateStatusChange}
                />
              </TabContainer>
            )}
            {value == 1 && (
              <TabContainer>
                <List
                  showOnlyList
                  list={this.state.customTemplates.data}
                  permissions={this.state.permissions}
                  headers={this.state.customTemplates.headers}
                  onEdit={this.onEdit}
                  onDelete={this.onDelete}
                  onPreview={this.onPreview}
                  onStateStatusChange={this.onStateStatusChange}
                />
                {/* <DefaultComp
                  heading="If you do not find what you were looking for in sumHR templates you can create your own templates here."
                  subheading={<AddAction label="Create new template" />}
                  imageSrc={emptyHrlist}
                /> */}
              </TabContainer>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { match, classes } = this.props;

    return (
      <div>
        <IntlProvider locale="en">
          <div className="content-outer-wrapper">
            {this.state.permissiondenied ? (
              <div className="position-rel">
                <PermissionDeniedComp />
              </div>
            ) : (
              <div>
                <Switch>
                  <Route
                    exact
                    path={`${match.path}`}
                    render={this.renderList}
                  />
                  <Route
                    exact
                    path={`${match.path}/create`}
                    render={this.renderCreate}
                  />
                  <Route
                    exact
                    path={`${match.path}/edit`}
                    render={this.renderEdit}
                  />
                  <Redirect from={`${match.path}`} to={`${match.path}`} />
                </Switch>
                <Drawer
                  anchor="right"
                  open={this.state.DrawerOpen}
                  onClose={() => this.openDrawer({ DrawerOpen: false })}
                  classes={{
                    paper: classNames(
                      classes.drawerPaper,
                      "planner-drawer padding15",
                    ),
                  }}
                >
                  <DrawerHeader
                    header={
                      this.state.isfilter
                        ? "Filter and sort"
                        : "Select CC employees in mail"
                    }
                    isbackarrow={false}
                    closeDrawer={this.handleClickAway}
                  />
                  {this.state.isfilter && (
                    <div>
                      <div>
                        <DynamicForm
                          fields={selectinputconverter({
                            value: this.state.lettercategoryid,
                            label: "Letter category",
                            placeholder: "Select latter category",
                            options: this.state.lettercategories,
                          })}
                          onChange={(e) =>
                            this.handleChange("lettercategoryid", e)
                          }
                        />
                      </div>
                      <div style={{ marginTop: 20 }}>
                        <Button
                          variant="contained"
                          className="btn btn-secondary-md-blue margin-right-16"
                          color="primary"
                          onClick={() =>
                            this.setState(
                              { DrawerOpen: false, lettercategoryid: null },
                              () => this.getTemplates(),
                            )
                          }
                        >
                          Reset
                        </Button>
                        <Button
                          variant="contained"
                          className="btn btn-primary-md-blue margin-right-16"
                          color="primary"
                          onClick={this.onSubmit}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  )}
                  {this.state.isccemployees && (
                    <div>
                      <p>Select employees</p>
                      <Select
                        isMulti
                        className="selectsearch"
                        onChange={(id) =>
                          this.handleChange("selectedEmployeeIds", id)
                        }
                        options={this.state.allemployeeslist}
                        getOptionLabel={(option) => option.displayname}
                        getOptionValue={(option) => option.displayvalue}
                        value={this.state.selectedEmployees}
                        placeholder="Select employees"
                      />
                      <div
                        style={{
                          position: "fixed",
                          bottom: 16,
                          display: "flex",
                          justifyContent: "space-between",
                          width: "30%",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          className="btn btn-primary-md-blue"
                          color="primary"
                          onClick={this.createLetterConfig}
                        >
                          Save
                        </Button>
                        <Button
                          className="btn btn-trans"
                          onClick={() =>
                            this.setState({
                              DrawerOpen: false,
                              isccemployees: false,
                            })
                          }
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  )}
                </Drawer>
              </div>
            )}
          </div>
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(withSnackbar(Templates))),
);
